var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vlt-loading"},[(!_vm.isEdge)?_c('img',{staticClass:"loading-ico",attrs:{"src":require("@/assets/icons/loading.svg"),"alt":"loader","loading":"lazy"}}):_c('div',{staticClass:"alternateLoader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }